module.exports = __webpack_public_path__ + "img/feature_buy_en.da99df7a.png";